export default __webpack_public_path__ + "static/media/fnb.869e37f2.jpg";